'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _history = require('history');

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactFavicon = require('react-favicon');

var _reactFavicon2 = _interopRequireDefault(_reactFavicon);

var _auth = require('../auth/auth');

var _auth2 = _interopRequireDefault(_auth);

var _countdown = require('../countdown/countdown');

var _countdown2 = _interopRequireDefault(_countdown);

var _curtain = require('../curtain/curtain');

var _curtain2 = _interopRequireDefault(_curtain);

var _sound = require('../sound/sound');

var _sound2 = _interopRequireDefault(_sound);

var _overlay = require('../overlay/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _navigation = require('../navigation/navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _showbag = require('../showbag/showbag');

var _showbag2 = _interopRequireDefault(_showbag);

var _giftCards = require('../gift-cards/gift-cards');

var _giftCards2 = _interopRequireDefault(_giftCards);

var _entry = require('../entry/entry');

var _entry2 = _interopRequireDefault(_entry);

var _lobby = require('../lobby/lobby');

var _lobby2 = _interopRequireDefault(_lobby);

var _hall = require('../hall/hall');

var _hall2 = _interopRequireDefault(_hall);

var _booth = require('../booth/booth');

var _booth2 = _interopRequireDefault(_booth);

var _logger = require('../logger/logger');

var _logger2 = _interopRequireDefault(_logger);

var _policy = require('../policy/policy');

var _policy2 = _interopRequireDefault(_policy);

var _fundraising = require('../fundraising/fundraising');

var _fundraising2 = _interopRequireDefault(_fundraising);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Expo = function (_Component) {
  _inherits(Expo, _Component);

  /** @constructor
    * Constructs a new expo instance using the supplied properties.
    */
  function Expo(props) {
    _classCallCheck(this, Expo);

    var _this = _possibleConstructorReturn(this, (Expo.__proto__ || Object.getPrototypeOf(Expo)).call(this, props));

    _this.history = (0, _history.createHashHistory)();
    _this.history.listen(function (location, action) {
      if (window.vexpo && window.vexpo.log) window.vexpo.log('navigated to ' + location.pathname);
    });
    return _this;
  }
  /** @method componentWillMount
    * Adds the firebase instance to the global vexpo object.
    */


  _createClass(Expo, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!window.vexpo) window.vexpo = {};
      window.vexpo.firebase = this.props.firebase;
      window.vexpo.history = this.history;
      window.vexpo.databaseRef = this.props.firebase.database().ref('expos/' + this.props.expoID + '/shows/' + this.props.showID);
    }
    /** @method render
      * Renders the Expo component
      */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = this.props.messages || {};
      var entry = this.props.isSample ? "" : _react2.default.createElement(_entry2.default, { name: this.props.name, logo: this.props.logo, sponsors: this.props.sponsors, fundraising: this.props.fundraising, opens: this.props.opens, closes: this.props.closes, welcomeVideo: this.props.welcomeVideo, beneficiaries: this.props.beneficiaries, deals: this.props.deals, exhibitors: this.props.exhibitors, stage: this.props.entry.stage, supportEmail: this.props.supportEmail });
      return _react2.default.createElement(
        _reactRouterDom.Router,
        { history: this.history },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_reactFavicon2.default, { url: this.props.icon }),
          _react2.default.createElement(_overlay2.default, null),
          _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            _react2.default.createElement(_reactRouterDom.Route, { path: '/entry', render: function render(_ref) {
                var match = _ref.match;
                return _react2.default.createElement(_entry2.default, { name: _this2.props.name, logo: _this2.props.logo, sponsors: _this2.props.sponsors, fundraising: _this2.props.fundraising, opens: _this2.props.opens, closes: _this2.props.closes, welcomeVideo: _this2.props.welcomeVideo, beneficiaries: _this2.props.beneficiaries, deals: _this2.props.deals, exhibitors: _this2.props.exhibitors, stage: _this2.props.entry.stage });
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/tos', render: function render() {
                return _react2.default.createElement(_policy2.default, { content: _this2.props.tos, name: _this2.props.name });
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/privacy', render: function render() {
                return _react2.default.createElement(_policy2.default, { content: _this2.props.privacy, name: _this2.props.name });
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/registry', render: function render(_ref2) {
                var match = _ref2.match;
                return _react2.default.createElement(
                  'h1',
                  null,
                  'Gift Registry'
                );
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/fundraising/:token', render: function render(_ref3) {
                var match = _ref3.match;
                return _react2.default.createElement(_fundraising2.default, { expoID: _this2.props.expoID, showID: _this2.props.showID, name: _this2.props.name, supportEmail: _this2.props.supportEmail, image: _this2.props.fundraising, video: _this2.props.fundraisingVideo, exhibitors: _this2.props.exhibitors, deals: _this2.props.deals, beneficiaries: _this2.props.beneficiaries, stage: _this2.props.entry.stage, logo: _this2.props.logo, token: match.params.token });
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/fundraising', render: function render(_ref4) {
                var match = _ref4.match;
                return _react2.default.createElement(_fundraising2.default, { expoID: _this2.props.expoID, showID: _this2.props.showID, name: _this2.props.name, supportEmail: _this2.props.supportEmail, image: _this2.props.fundraising, video: _this2.props.fundraisingVideo, exhibitors: _this2.props.exhibitors, deals: _this2.props.deals, beneficiaries: _this2.props.beneficiaries, stage: _this2.props.entry.stage, logo: _this2.props.logo });
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { render: function render(_ref5) {
                var match = _ref5.match;
                return _react2.default.createElement(
                  _auth2.default,
                  { isSample: _this2.props.isSample, logo: _this2.props.logo, stage: _this2.props.entry.stage, entry: entry },
                  _react2.default.createElement(_logger2.default, { firebase: _this2.props.firebase, expoID: _this2.props.expoID, showID: _this2.props.showID }),
                  _react2.default.createElement(
                    _countdown2.default,
                    { opens: _this2.props.opens, stage: _this2.props.entry.stage, logo: _this2.props.logo, isSample: _this2.props.isSample, expoID: _this2.props.expoID, showID: _this2.props.showID },
                    _react2.default.createElement(
                      _curtain2.default,
                      { closes: _this2.props.closes, stage: _this2.props.entry.stage, logo: _this2.props.logo, isSample: _this2.props.isSample },
                      _react2.default.createElement(_sound2.default, { backgroundNoise: _this2.props.backgroundNoise }),
                      _react2.default.createElement(_giftCards2.default, { expoID: _this2.props.expoID, showID: _this2.props.showID, background: _this2.props.giftCardsBackground, name: _this2.props.name, supportEmail: _this2.props.supportEmail, image: _this2.props.fundraising, video: _this2.props.fundraisingVideo, exhibitors: _this2.props.exhibitors, deals: _this2.props.deals, beneficiaries: _this2.props.beneficiaries, logo: _this2.props.logo, instructions: messages.giftCardUse }),
                      _react2.default.createElement(_showbag2.default, { background: _this2.props.showbagBackground, initialContents: _this2.props.showbagInitialContents, expoID: _this2.props.expoID, showID: _this2.props.showID }),
                      _react2.default.createElement(_navigation2.default, _this2.props),
                      _react2.default.createElement(
                        _reactRouterDom.Switch,
                        null,
                        _react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true, render: function render(_ref6) {
                            var match = _ref6.match;
                            return _react2.default.createElement(_lobby2.default, _this2.props.lobby);
                          } }),
                        _react2.default.createElement(_reactRouterDom.Route, { path: '/lobby', render: function render(_ref7) {
                            var match = _ref7.match;
                            return _react2.default.createElement(_lobby2.default, _extends({}, _this2.props.lobby, { welcomeVideo: _this2.props.welcomeVideo }));
                          } }),
                        _react2.default.createElement(_reactRouterDom.Route, { path: '/booth/:id', render: function render(_ref8) {
                            var match = _ref8.match;

                            var navLinks = [_react2.default.createElement(
                              'button',
                              { key: 'locations', onClick: function onClick() {
                                  if (window.vexpo && window.vexpo.showLocations) window.vexpo.showLocations();
                                } },
                              _react2.default.createElement(_reactFontawesome2.default, { name: 'map-signs' }),
                              'LOCATIONS'
                            ), _react2.default.createElement(
                              _reactRouterDom.Link,
                              { key: 'lobby', to: '/lobby' },
                              _react2.default.createElement(_reactFontawesome2.default, { name: 'home' }),
                              'LOBBY'
                            )];
                            return _react2.default.createElement(_booth2.default, _extends({}, _this2.props.booths[match.params.id], { boothID: match.params.id, navLinks: navLinks }));
                          } }),
                        _react2.default.createElement(_reactRouterDom.Route, { path: '/hall/:hallID', render: function render(_ref9) {
                            var match = _ref9.match;
                            return _react2.default.createElement(
                              'div',
                              { id: 'hall' },
                              _react2.default.createElement(_hall2.default, _extends({}, _this2.props.halls[match.params.hallID], { hallID: match.params.hallID })),
                              _react2.default.createElement(_reactRouterDom.Route, { path: "/hall/:hallID/booth/:id", render: function render(_ref10) {
                                  var match = _ref10.match;

                                  var hallID = match.params.hallID;
                                  var navLinks = [_react2.default.createElement(
                                    'button',
                                    { key: 'locations', onClick: function onClick() {
                                        if (window.vexpo && window.vexpo.showLocations) window.vexpo.showLocations();
                                      } },
                                    _react2.default.createElement(_reactFontawesome2.default, { name: 'map-signs' }),
                                    'LOCATIONS'
                                  ), _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { key: 'lobby', to: '/lobby' },
                                    _react2.default.createElement(_reactFontawesome2.default, { name: 'home' }),
                                    'LOBBY'
                                  ), _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { key: 'hall', to: "/hall/" + hallID },
                                    _react2.default.createElement(_reactFontawesome2.default, { name: 'flag' }),
                                    'Back to Hall'
                                  )];
                                  return _react2.default.createElement(_booth2.default, _extends({ id: 'booth' }, _this2.props.booths[match.params.id], { boothID: match.params.id, navLinks: navLinks }));
                                } })
                            );
                          } }),
                        _react2.default.createElement(_reactRouterDom.Route, { render: function render(_ref11) {
                            var match = _ref11.match;
                            return _react2.default.createElement(NotFound, null);
                          } })
                      )
                    )
                  )
                );
              } })
          )
        )
      );
    }
  }]);

  return Expo;
}(_react.Component);

exports.default = Expo;


var NotFound = function NotFound() {
  return _react2.default.createElement(
    'h1',
    null,
    'Not Found'
  );
};

Expo.propTypes = {
  expoID: _propTypes2.default.string.isRequired,
  showID: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  halls: _propTypes2.default.object.isRequired,
  booths: _propTypes2.default.object.isRequired,
  isSample: _propTypes2.default.bool.isRequired,
  exhibitorListingBackground: _propTypes2.default.string.isRequired,
  showLocationsBackground: _propTypes2.default.string.isRequired

};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/expo/expo.js
// module id = 1348
// module chunks = 0